const SERVICE_KINDS = ['wrap', 'ppf', 'tint', 'ceramic', 'print'];
function isFiniteNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
}
export function getAddonLineMarker(breakdown) {
    if (!breakdown)
        return null;
    const marker = breakdown.addon;
    if (marker === null || typeof marker !== 'object' || Array.isArray(marker))
        return null;
    const candidate = marker;
    if (typeof candidate.addonServiceId !== 'string')
        return null;
    if (candidate.pricingType !== 'flat' && candidate.pricingType !== 'hourly')
        return null;
    if (!isFiniteNumber(candidate.rateCents))
        return null;
    if (!isFiniteNumber(candidate.minutes))
        return null;
    return {
        addonServiceId: candidate.addonServiceId,
        pricingType: candidate.pricingType,
        rateCents: candidate.rateCents,
        minutes: candidate.minutes,
    };
}
export function getCategoryMinimumLineMarker(breakdown) {
    if (!breakdown)
        return null;
    const marker = breakdown.categoryMinimumAdjustment;
    if (marker === null || typeof marker !== 'object' || Array.isArray(marker))
        return null;
    const candidate = marker;
    if (typeof candidate.category !== 'string' || !SERVICE_KINDS.includes(candidate.category))
        return null;
    if (!isFiniteNumber(candidate.minCents))
        return null;
    return {
        category: candidate.category,
        minCents: candidate.minCents,
    };
}
export function getDefaultMinimumLineMarker(breakdown) {
    if (!breakdown)
        return null;
    const marker = breakdown.defaultMinimumAdjustment;
    if (marker === null || typeof marker !== 'object' || Array.isArray(marker))
        return null;
    const candidate = marker;
    if (!isFiniteNumber(candidate.minCents))
        return null;
    return { minCents: candidate.minCents };
}
// True when the line is one of the two synthetic minimum adjustment lines
// (category or default). These lines are stripped and rebuilt on every save.
export function isMinimumAdjustmentLine(breakdown) {
    return getCategoryMinimumLineMarker(breakdown) !== null || getDefaultMinimumLineMarker(breakdown) !== null;
}
//# sourceMappingURL=quote-adjustments.js.map